import type { DomainManifest } from 'modules/core/lib/manifests/types'

import { useCreateProject } from 'modules/project_management/lib/oneHandlers/project/create-project'
import { sidebarManifest } from 'modules/project_management/lib/manifest/sidebar'

export const manifest = {
  sidebar: (navigation) => ({
    items: sidebarManifest(navigation),
  }),
  one: {
    createActions: {
      project: {
        actionResolver: useCreateProject,
        policies: ['ProjectManagement_projectCreate'],
        module: 'company_projects',
      },
    },
  },
} as const satisfies DomainManifest
